module.exports = {
  __depends__: [
    require(233),
    require(155),
    require(260)
  ],
  __init__: [ 'editorActions' ],
  editorActions: [ 'type', require(163) ]
};
